import {Heading, Text} from '@primer/react'

import {DiffViewSettings} from './DiffViewSettings'
import {LinesChangedCounterLabel} from '@github-ui/diff-file-header'
import type {HeaderInfo} from '../../types/commit-types'

interface DiffsHeaderProps {
  headerInfo: HeaderInfo
  treeToggleElement: JSX.Element
}

export function DiffsHeader({treeToggleElement, headerInfo}: DiffsHeaderProps) {
  return (
    <div className="d-flex flex-items-center flex-justify-between gap-2">
      <div className="d-flex flex-items-center">
        {treeToggleElement}
        <Heading as="h2" sx={{fontSize: 2, mx: 2}}>
          {headerInfo.filesChangedString} file{headerInfo.filesChanged > 1 ? 's' : ''} changed
        </Heading>
        <LinesChangedCounterLabel isAddition>+{headerInfo.additions}</LinesChangedCounterLabel>
        <LinesChangedCounterLabel isAddition={false}>-{headerInfo.deletions}</LinesChangedCounterLabel>
        <Text sx={{fontSize: 0, ml: 2, color: 'fg.muted', whiteSpace: 'nowrap'}}>lines changed</Text>
      </div>
      <DiffViewSettings />
    </div>
  )
}

try{ DiffsHeader.displayName ||= 'DiffsHeader' } catch {}